/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractDto } from '../../models/backend-leasing-contract-dto';

export interface FinancingSourcesLeasingsRetrieve$Params {
  /**
   * A unique integer value identifying this leasing contract.
   */
  id: number;
}

export function financingSourcesLeasingsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractDto>;
    }),
  );
}

financingSourcesLeasingsRetrieve.PATH = '/api/financing_sources/leasings/{id}/';
